"use strict";

var _regeneratorRuntime = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TXs = void 0;

var methods_1 = require("../communication/methods");

var TXs = /*#__PURE__*/function () {
  function TXs(communicator) {
    _classCallCheck(this, TXs);

    this.communicator = communicator;
  }

  _createClass(TXs, [{
    key: "getBySafeTxHash",
    value: function () {
      var _getBySafeTxHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(safeTxHash) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (safeTxHash) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Invalid safeTxHash');

              case 2:
                _context.next = 4;
                return this.communicator.send(methods_1.Methods.getTxBySafeTxHash, {
                  safeTxHash: safeTxHash
                });

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBySafeTxHash(_x) {
        return _getBySafeTxHash.apply(this, arguments);
      }

      return getBySafeTxHash;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message) {
        var messagePayload, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                messagePayload = {
                  message: message
                };
                _context2.next = 3;
                return this.communicator.send(methods_1.Methods.signMessage, messagePayload);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signMessage(_x2) {
        return _signMessage.apply(this, arguments);
      }

      return signMessage;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var txs, params, messagePayload, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                txs = _ref.txs, params = _ref.params;

                if (!(!txs || !txs.length)) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('No transactions were passed');

              case 3:
                messagePayload = {
                  txs: txs,
                  params: params
                };
                _context3.next = 6;
                return this.communicator.send(methods_1.Methods.sendTransactions, messagePayload);

              case 6:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function send(_x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return TXs;
}();

exports.TXs = TXs;